/// <amd-module name="Feed/Legacy/Protocols/Components/MarkdownRendererWrapper" />
import * as React from "react";

import { BaseComponent, IBaseProps } from "OfficeFabric/Utilities";

import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IMarkdownRendererProps extends IBaseProps {
    pageContext: IVssPageContext;
    rawMarkdownContent: string;
}

export interface IMarkdownRendererState {
    markdownHtml: string;
}

export class MarkdownRendererWrapper extends BaseComponent<IMarkdownRendererProps, IMarkdownRendererState> {
    constructor(props: IMarkdownRendererProps) {
        super(props);
        this.state = {
            markdownHtml: ""
        };
    }

    public componentDidMount(): void {
        this.renderContent();
    }

    public render(): JSX.Element {
        if (this.state.markdownHtml === "") {
            return null;
        }

        // Note: doing lambda/anonymous function here forces react to run the ref on each update. This is needed since it can't detect the differences in inner html.
        return (
            <div
                ref={div => {
                    this.LegacyPlatformService.requireModules(["ContentRendering/Markdown"]).then(
                        ([markdownModule]) => {
                            markdownModule.UserContentAnchorHelper.attach(div);
                        }
                    );
                }}
                className="rendered-markdown"
                dangerouslySetInnerHTML={{ __html: this.state.markdownHtml }}
            />
        );
    }

    private get LegacyPlatformService() {
        return this.props.pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");
    }

    private renderContent(): void {
        const promise = this.LegacyPlatformService.requireModules(["ContentRendering/Markdown"]);
        promise.then(([markdownModule]) => {
            this._async.setImmediate(() => {
                const renderer = new markdownModule.MarkdownRenderer();
                const resultHtml: string = renderer.renderHtml(this.props.rawMarkdownContent);

                this.setState({
                    markdownHtml: resultHtml
                } as IMarkdownRendererState);
            });
        });
    }
}
